/**
 * 🔥 AuthContext global - Charge les permissions UNE SEULE FOIS
 * Cache les données d'auth pour toute la session
 * Plus de vérification à chaque page!
 */
import React, { createContext, useContext, ReactNode } from 'react';
import { useAuthComplete, CompleteAuthState } from '@/hooks/useAuthComplete';

const AuthContext = createContext<CompleteAuthState | null>(null);

// ✅ Provider global qui charge auth UNE FOIS
export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const authState = useAuthComplete(); // Appelé UNE SEULE FOIS à la racine
  
  return (
    <AuthContext.Provider value={authState}>
      {children}
    </AuthContext.Provider>
  );
};

// ✅ Hook qui retourne le cache
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};
